import 'css-chunksrc/feature/flip-and-tip/FlipAndTipCheck.module.scss';export default {
  "root": "FlipAndTipCheck_root",
  "items": "FlipAndTipCheck_items",
  "item_grid": "FlipAndTipCheck_item_grid",
  "item_grid_fill": "FlipAndTipCheck_item_grid_fill",
  "modifier_name": "FlipAndTipCheck_modifier_name",
  "footer": "FlipAndTipCheck_footer",
  "totals": "FlipAndTipCheck_totals"
};